import React from "react";
import "./ForgotPassword.css";
import forpass from "../../assets/ForgetPasswordBg.svg";

const ForgotPassword = () => {
  const submitHandler = (e) => {
    e.preventDefault();
    alert("submit");
  };

  return (
    <div className="forgot-password-container">
      <section className="forgot-password-1">
        <img className="forgot-password-1-img" src={forpass} alt="logo" />
      </section>
      <div>
        <section className="forgot-password-2">
          <h3 className="forgot-password-2-heading">Trouble Logging in ?</h3>
          <span className="forgot-password-2-desc">
            Please enter your username and phone number, we'll send you otp to
            reset your password.
          </span>
          <form onSubmit={submitHandler} className="forgot-password-2form">
            <label className="forgot-password-2-label" htmlFor="username">
              Username
            </label>
            <input
              placeholder="Enter username"
              className="forgot-password-2-input"
              type="text"
              id="username"
            />
            <label className="forgot-password-2-label" htmlFor="phone">
              Phone Number
            </label>
            <input
              placeholder="Enter Phone Number"
              className="forgot-password-2-input"
              type="tel"
              id="phone"
            />
            <section className="forgot-password-2-btn-section">
              <button className=" button forgot-password-2-btn">
                SEND OTP
              </button>
            </section>
          </form>
        </section>
      </div>
    </div>
  );
};

export default ForgotPassword;
